import FormImages from "../components/Form/assets/images.js";

var allImages = [];

const loadImages = (imageUrls) => {
  imageUrls.forEach((q) => {
    const img = new Image();
    img.src = q;
    allImages.push(img);
  });
};

const images = [
  require("./images/popup-delete.svg"),
  require("./images/popup-error.svg"),
  require("./images/popup-success.svg"), 
  require("./images/popup-warn.svg"),
  require("./images/profile_default.svg"),
];

const icons = [
  require("./icons/arrow-down.svg"),
  require("./icons/back.svg"),
  require("./icons/close.svg"),
  require("./icons/notification.svg"),
  require("./icons/profile.svg"),
  require("./icons/logout.svg"),
  require("./icons/search.svg"),
  require("./icons/pagination-back-all.svg"),
  require("./icons/pagination-back-previous.svg"),
  require("./icons/pagination-next-all.svg"),
  require("./icons/pagination-next.svg"),
];

const preloadImages = () => {
  loadImages([...FormImages, ...icons, ...images]);
};

export default preloadImages;
